// extracted by mini-css-extract-plugin
export default {"container":"Step_container__6317K","stepContainer":"Step_stepContainer__mRE7p","h2":"Step_h2__9FloP"};